import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import {
    CeButtonComponent,
    CeParameterListImports,
    CePillComponent,
    RouterLinkInput,
} from '@kempower-nx-workspace/shared/kp-design-system';
import { formatTimeAndDate } from '@kempower-nx-workspace/global-toolkit';
import { TruncateSoCPipe } from '../../utils/truncate-soc.pipe';
import {
    EnrichedFrontendNotification,
    GetNotificationEmailSentTimestampResponse,
} from '../../data-access/notification-data/notification-data.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'ce-notification-depot-operation-content',
    imports: [
        CeButtonComponent,
        CeParameterListImports,
        CePillComponent,
        TruncateSoCPipe,
        RouterLink,
    ],
    templateUrl: './notification-depot-operation-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDepotOperationContentComponent {
    notification = input.required<EnrichedFrontendNotification>();
    emailTimestamp = input<GetNotificationEmailSentTimestampResponse | undefined>();
    detailsRouterLink = input.required<RouterLinkInput>();
    detailsQueryParams = input.required<Record<string, string> | undefined>();
    tooltipText = input.required<string>();
    linkLabel = input.required<string>();

    hasMultipleEvents: Signal<boolean> = computed(() => this.notification().events.length > 1);

    formattedEvents = computed(() =>
        this.notification().events.map((event) => ({
            ...event,
            formattedTimestamp: event.timestamp ? formatTimeAndDate(event.timestamp) : '',
            formattedResolvedTimestamp: event.resolvedTimestamp ? formatTimeAndDate(event.resolvedTimestamp) : '',
        })),
    );

    isScheduledSessionEndedUnexpectedly: Signal<boolean> = computed(() => {
        return this.notification().eventType === 'scheduled-session-ended-unexpectedly';
    });

    showResolutionReason: Signal<boolean> = computed(() => {
        return (
            this.notification().events.length === 1 &&
            !!this.notification().events[0]?.resolvedTimestamp &&
            !!this.notification().events[0]?.resolutionReason
        );
    });
}
